import { render, staticRenderFns } from "./JournalEntrySCIRE.vue?vue&type=template&id=fbd1ef82"
import script from "./JournalEntrySCIRE.vue?vue&type=script&lang=js"
export * from "./JournalEntrySCIRE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports